var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order"},[_c('c-head'),_c('div',{staticClass:"bread"}),_c('c-foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }